<template>
    <div class="col-sm-12">
        <b-col lg="12" class="no-gutters" v-if="!editMode">
            <h3 class="resource-title mb-5">{{ $t('page.users')}}</h3>
        </b-col>
        <transition name="fade">
            <user-list
                    v-if="!editMode"
                    :results="results"
                    @edit="editUser"
            />
        </transition>
        <transition name="fade">
            <user-editor
                    v-if="editMode"
                    :user="user"
                    @close="showList"
                    @closeAndUpdate="closeAndUpdate"
                    @alert="showAlert"
            />
        </transition>
        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>
</template>


<script>
    import UserList from './UserList'
    import UserEditor from './UserEditor'
    import FairApi from '../../modules/api'

    export default {
        name: 'users',
        components: {UserList, UserEditor},
        data: function () {
            return {
                results: [],
                user: null,
                editMode: false,
                loading: true
            }
        },
        created: function () {
            this.fetchUsers()
        },
        methods: {
            fetchUsers: function () {
                this.loading = true
                FairApi.get(FairApi.users(), this.fetchUsersSuccess, this.fetchUsersFail)
            },

            fetchUsersSuccess: function (response) {
                this.results = response
                this.loading = false
            },

            fetchUsersFail: function (response) {
                this.loading = false
                if (response.status === 401) {
                    this.$emit('logOut')
                }
                this.showAlert(this.$t('common.fetch_failed'))
            },

            editUser: function (user) {
                this.user = user
                this.editMode = true
            },

            showList: function () {
                this.editMode = false
            },

            showAlert: function (msg) {
                this.$emit('alert', msg)
            },

            closeAndUpdate: function () {
                this.showList()
                this.fetchUsers()
            }
        }
    }
</script>
